<template>
  <div class="dashboard-tabla-resultados cheques-propios">
    <div class="dashboard-tabla-resultados-header">
      <h4>Resumen Semanal de Cheques Propios</h4>
    </div>
    <div class="dashboard-tabla-resultados-data">
      <b-table hover
          responsive="sm" 
          class="table-dashboard resumen"
          :busy="tableBusy"
          :items="resumenSemanal" 
          :fields="fields"
          :current-page="paginaActual"
          :per-page="registrosPorPagina">
        <div slot="table-busy" class="text-center">
          <b-spinner class="table-spinner" label="Spinning" />
        </div>              
        <template v-slot:cell(periodo)="data">
          {{ data.item.periodo | fecha }}
        </template>
        <template v-slot:cell(importe)="data">
          {{ data.item.importe | moneda }}
        </template>
        
        <template v-slot:cell(detailShowing)="row">
          <b-btn class="detailShowing" 
              size="sm" 
              @click.stop="row.toggleDetails">
            {{ ( row.detailsShowing) ? '-' : '+' }}
          </b-btn>            
        </template>

        <template v-slot:row-details="row">
          <b-table hover
              responsive="sm" 
              class="table-dashboard cheques"
              :busy="tableBusy"
              :items="row.item.chequesPropios" 
              :fields="chequesPropiosFields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaPago)="data">
              {{ data.item.fechaPago | fecha }}
            </template>
            <template v-slot:cell(fechaIngreso)="data">
              {{ data.item.fechaIngreso | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
          </b-table>
        </template>
      </b-table>
      <nav>
        <b-pagination size="sm" 
          :total-rows="totalRegistros" 
          :per-page="registrosPorPagina" 
          v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
      </nav>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../../shared/msjModal.vue';
import { msjModal } from '../../../mixins/modalDialogs';

export default {
  name: 'DashboardChequesPropios',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      resumenSemanal: [],

      fields: [
        {
            key: 'detailShowing',
            label: '',
            class: 'text-center'
        },
        { 
          key: 'periodo',
          label: 'Semana'
        },
        {
          key: 'cantidad',
          label: 'Cheques',
          class: 'text-right',
        },
        {
          key: 'importe',
          label: 'Importe Total',
          class: 'text-right',
        },
      ],

      chequesPropiosFields: [
        { key: 'fechaPago' },
        { key: 'fechaIngreso' },
        { 
          key: 'bancoCuenta',
          label: 'Cuenta'
        },
        { key: 'proveedor' },
        {
          key: 'numero',
          class: 'text-right',
        },
        {
          key: 'importe',
          class: 'text-right',
        },
      ],

      tableBusy: false,
      paginaActual: 1,
      totalPaginas: 1,
      registrosPorPagina: 10,
      totalRegistros: 0,
    }
  },
  methods: {
    getResultados() {
    this.tableBusy = true;
    this.$store.dispatch('chequespropios/getResumenSemanal')
      .then(() => {
        this.resumenSemanal = this.$store.getters['chequespropios/resumenSemanal'];
        this.totalRegistros = this.resumenSemanal.length;
        this.tableBusy = false;
      })
      .catch(error => this.showErrorMsj(error));
    }
  },
}
</script>

<style>
  .dashboard-tabla-resultados.cheques-propios .table-dashboard.resumen table td[aria-colindex="1"] {
    width: 30px;
  }
  .dashboard-tabla-resultados.cheques-propios .table-dashboard.resumen table td[aria-colindex="2"] {
    width: calc(50% - 30px);
  }
  .dashboard-tabla-resultados.cheques-propios .table-dashboard.resumen table td[aria-colindex="3"] {
    width: 20%;
  }
  .dashboard-tabla-resultados.cheques-propios .table-dashboard.resumen table td[aria-colindex="4"] {
    width: 30%;
  }

  .dashboard-tabla-resultados.cheques-propios .table-dashboard.resumen table .b-table-details td {
    padding-left: 30px;
    padding-right: 0;
  }

  .dashboard-tabla-resultados.cheques-propios .table-dashboard.cheques table td[aria-colindex="1"] {
    width: 10%;
  }
  .dashboard-tabla-resultados.cheques-propios .table-dashboard.cheques table td[aria-colindex="2"] {
    width: 10%;
  }
  .dashboard-tabla-resultados.cheques-propios .table-dashboard.cheques table td[aria-colindex="3"] {
    width: 20%;
  }
  .dashboard-tabla-resultados.cheques-propios .table-dashboard.cheques table td[aria-colindex="4"] {
    width: 40%;
  }
  .dashboard-tabla-resultados.cheques-propios .table-dashboard.cheques table td[aria-colindex="5"] {
    width: 10%;
  }
  .dashboard-tabla-resultados.cheques-propios .table-dashboard.cheques table td[aria-colindex="6"] {
    width: 10%;
  }

</style>
